export default __webpack_public_path__ + "navigator.538e75e737b301ff8427fb8bd8c60cd0.svg";